import React, { FC, ReactElement } from 'react';
import { Anchor, Box, Nav, Paragraph, Text } from 'grommet';
import { MenuItem } from '@/types';
import { links, terms } from '@/data';
import { Link } from 'gatsby';
import { LogoFooter } from './LogoFooter';

const NavMenu: FC<{ items: MenuItem[] }> = ({ items }): ReactElement => (
  <Nav>
    {items.map((item) => (
      <Anchor
        size="xsmall"
        color={{ light: `dark-4`, dark: `light-1` }}
        key={item.path}
        as={Link}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        to={item.path}
        label={item.label}
      />
    ))}
  </Nav>
);

export const Footer: FC = (): ReactElement => (
  <Box as="footer" flex={false} gap="xsmall">
    <Box
      align="start"
      direction="row-responsive"
      flex={false}
      gap="small"
      justify="between"
    >
      <Box border={{ side: `right` }} pad={{ right: `medium` }}>
        <LogoFooter />
        <Paragraph>
          We are a cybersecurity technology platform that has sourced the tools,
          methods, and techniques attackers use. Our system allows owners and
          operators to find potential risks and exposures before attackers do.
        </Paragraph>
      </Box>
      <Box gap="medium">
        <Text size="small" weight="bolder">
          Useful Links
        </Text>
        <NavMenu items={links} />
      </Box>
      <Box gap="medium">
        <Text size="small" weight="bolder">
          Terms
        </Text>
        <NavMenu items={terms} />
      </Box>
      <Box gap="medium">
        <Text size="small" weight="bolder">
          Contact Us
        </Text>
        <Box>
          <Text truncate>
            <Anchor size="small" href="mailto:contact@pentester.com">
              contact@pentester.com
            </Anchor>
          </Text>
          <Text
            margin={{ top: `small` }}
            size="small"
            color={{ light: `dark-4`, dark: `light-1` }}
          >
            20283 State Road 7, Suite 108
          </Text>
          <Text size="small" color={{ light: `dark-4`, dark: `light-1` }}>
            Boca Raton, Florida
          </Text>
          <Text size="small" color={{ light: `dark-4`, dark: `light-1` }}>
            33434
          </Text>
        </Box>
      </Box>
    </Box>
    <Box justify="between" direction="row-responsive" align="center">
      <Box>
        <Text size="small">
          By conducting scans you agree to our{` `}
          <Anchor
            as={Link}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            to="/terms-and-conditions"
            label="Terms"
          />
        </Text>
        <Paragraph>
          Copyright by Pentester, LLC <br />
          {new Date().getFullYear()}, All Rights Reserved.
        </Paragraph>
      </Box>
      <div id="recaptcha" />
    </Box>
  </Box>
);
